export function Aside({ mods = "color-quiet pad-2x", children }: { mods?: string | undefined; children: React.ReactNode }): React.ReactElement {
	return <aside className={mods}>{children}</aside>;
}

export const ASIDE = <Aside>{null}</Aside>;
